import './index.scss'
$("header .nav li").eq(1).addClass("active");
$(".nei-nav ul li").eq(3).addClass("active");
$(".culture-pic .pic").eq(0).addClass("active");
$(".culture-nav li").eq(0).addClass("active");
$(".culture-nav li").hover(function () {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".culture-pic .pic").eq(index).addClass("active").siblings().removeClass("active");
})